import { ReactNode } from "react"
import clsx from "clsx"
import { ButtonSize, ButtonVariant, sizeStyles, variantStyles } from "./constants"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  size?: ButtonSize
  variant?: ButtonVariant
  leftIcon?: ReactNode
  rightIcon?: ReactNode
}

export default function Button({ children, size="large", variant="filled", leftIcon, rightIcon, className, ...props }: ButtonProps) {
  return (
    <button aria-label="custom-button" className={clsx("inline-flex items-center justify-center transition-colors rounded-[10px] uppercase",
      sizeStyles[size], variantStyles[variant], className )} {...props}
    >
      {leftIcon && <span className="flex items-center mr-[9px]">{leftIcon}</span>}
      <span>{children}</span>
      {rightIcon && <span className="flex items-center ml-[9px]">{rightIcon}</span>}
    </button>
  )
}